<template>
  <va-dropdown
    class="profile-dropdown"
    v-model="isShown"
    boundary-body
    offset="0, 16px"
  >
    <span
      class="profile-dropdown__anchor" slot="anchor"
      :style="{color: this.$themes.primary}"
    >
      <slot/>
      <va-icon
        class="pa-1"
        :name="`fa ${isShown ? 'fa-angle-up' :'fa-angle-down'}`"
      />
    </span>
    <div class="profile-dropdown__content pl-4 pr-4 pt-2 pb-2 text--center">
      <va-button @click="logout" flat small class="profile-dropdown__item px-0 mx-0">{{ $t(`user.logout`) }}</va-button>
    </div>
  </va-dropdown>
</template>

<script>
export default {
  name: 'profile-section',
  data () {
    return {
      isShown: false,
    }
  },
  methods: {
    logout() {
      localStorage.removeItem('admin_token');
      delete $axios.defaults.headers.common['api-token'];
      this.$router.push({ path: 'giris' })
    }
  }
}
</script>

<style lang="scss">
$theme-primary: #ed4817;
.profile-dropdown {
  cursor: pointer;

  &__anchor {
    color: $theme-primary;
  }
  .va-dropdown-popper__anchor {
    display: flex;
    justify-content: flex-end;
  }
  &__content {
    background-color: $dropdown-background;
    box-shadow: $gray-box-shadow;
    border-radius: .5rem;
    width: 8rem;
  }
  &__item {
    display: block;
    color: $vue-darkest-blue!important;

    &:hover, &:active {
      color: $theme-primary!important;
      background: none!important;
    }
  }

  .va-dropdown__anchor {
    display: inline-block;
    margin-bottom: 5px;
  }

  .profile-dropdown__item {
    background: transparent!important;
  }
}
</style>
